import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StingrayCommonModule } from '@modules/common/common.module';
import { PortalConfigHeaderComponent } from '@modules/portal-config-shared/components/portal-config-header/portal-config-header.component';

@NgModule({
    declarations: [
        PortalConfigHeaderComponent
    ],
    imports: [
        CommonModule,
        StingrayCommonModule
    ],
    exports: [
        PortalConfigHeaderComponent
    ]
})
export class PortalConfigSharedModule {
}
